// External
import { createStore, applyMiddleware, compose } from "redux";
import { createBrowserHistory } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";

import { rootReducer, rootState } from "./rootReducer";
// eslint-disable-next-line
export let store;
export default function configureStore() {
  const enhancers = [];
  const history = createBrowserHistory();
  const reduxRouterMiddleware = routerMiddleware(history);
  const middlewares = [
    reduxRouterMiddleware,
  ];
  middlewares.push(thunkMiddleware);

  if (process.env.NODE_ENV === "development" || process.env.REACT_APP_ENV === "development" || process.env.REACT_APP_ENV === "qa") {
    const logger = createLogger({
      collapsed: true,
    });
    middlewares.push(logger);

    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (typeof devToolsExtension === "function") {
      enhancers.push(devToolsExtension());
    }
  }

  const composedEnhancers = compose(applyMiddleware(...middlewares), ...enhancers);
  store = createStore(connectRouter(history)(rootReducer, rootState), composedEnhancers);
  return { store, history };
}
